<template>
	<div class="Component">
		<WarningMatific :cancel="deleteNotMatific" :resume="deleteMatific" v-show="hasMatific && gameConfigs.length > 1" />
		<form class="ComponentForm" @submit.prevent="saveHomework">
			<draggable v-model="gameConfigs" group="configs" @start="drag = true" @end="drag = false">
				<GameConfig v-for="(config, i) in gameConfigs" :length="config.length" :index="i" :config="config"
					:ref="`config-${i}`" :hasMatific="hasMatific" @deleteConfig="deleteConfig(i)" @copyConfig="copyConfig"
					:key="i" @moveOrder="moveOrder" />
			</draggable>

			<div class="control-buttons">
				<button @click.prevent="$router.go(-1)" class="mybtn-outline mybtn-outline-violet">
					<i class="fa fa-arrow-left" aria-hidden="true" />

					{{ 'Back' | translate }}
				</button>
				<button class="mybtn-outline" v-if="!hasMatific" @click.prevent="addGameConfig">
					<i class="fa fa-plus" aria-hidden="true" />
					{{ 'Create' | translate }}
				</button>

				<button v-if="!!gameConfigs.length" @click.prevent="
					$route.query.homework
						? (showModalUpdateLesson = true)
						: saveHomework()
					" class="mybtn-outline">
					<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M17.12 5.71L12.29 0.88C11.7279 0.31723 10.9654 0.000700208 10.17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V15C0 15.7956 0.316071 16.5587 0.87868 17.1213C1.44129 17.6839 2.20435 18 3 18H15C15.7956 18 16.5587 17.6839 17.1213 17.1213C17.6839 16.5587 18 15.7956 18 15V7.83C17.9993 7.03462 17.6828 6.27207 17.12 5.71ZM7 16V14H11V16H7ZM16 15C16 15.2652 15.8946 15.5196 15.7071 15.7071C15.5196 15.8946 15.2652 16 15 16H13V13C13 12.7348 12.8946 12.4804 12.7071 12.2929C12.5196 12.1054 12.2652 12 12 12H6C5.73478 12 5.48043 12.1054 5.29289 12.2929C5.10536 12.4804 5 12.7348 5 13V16H3C2.73478 16 2.48043 15.8946 2.29289 15.7071C2.10536 15.5196 2 15.2652 2 15V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H5V7C5 7.26522 5.10536 7.51957 5.29289 7.70711C5.48043 7.89464 5.73478 8 6 8H10C10.2652 8 10.5196 7.89464 10.7071 7.70711C10.8946 7.51957 11 7.26522 11 7C11 6.73478 10.8946 6.48043 10.7071 6.29289C10.5196 6.10536 10.2652 6 10 6H7V2H10.17C10.4348 2.00368 10.6884 2.10727 10.88 2.29L15.71 7.12C15.8027 7.21344 15.876 7.32426 15.9258 7.44609C15.9755 7.56793 16.0008 7.69839 16 7.83V15Z"
							fill="#E69C50" />
					</svg>

					{{ 'Save' | translate }}
				</button>

				<ModalUpdateLesson :show="showModalUpdateLesson" @close="showModalUpdateLesson = false"
					@updateLesson="saveHomework" />
			</div>
			<!--			<div class='col-12' v-if='!!gameConfigs.length'>-->
			<!--				<button-->
			<!--					@click.prevent='deleteHomework'-->
			<!--					v-if='$route.query.homework !== undefined'-->
			<!--					class='btn btn-danger'-->
			<!--				>-->
			<!--					{{ 'Delete' | translate }}-->
			<!--				</button>-->
			<!--			</div>-->
		</form>
	</div>
</template>

<script>
import GameConfig from './GameConfig'
import WarningMatific from './WarningMatific'
import ModalUpdateLesson from '../Modal/UpdateLesson.vue'
import { defaultGameConfig } from '../../Games/gameConfig'
import { getTime } from '@/helpers/getTime'
import draggable from 'vuedraggable'

export const DEFAULT_ADDITION_OPTIONS = {
	...defaultGameConfig.addition,
	calculation_method: 'oral',
}

export const DEFAULT_ANZAN_OPTIONS = {
	...defaultGameConfig.anzan,
	calculation_method: 'oral',
}

export const DEFAULT_ABACUS_RANDOM_OPTIONS = {
	...defaultGameConfig.abacusRandom,
	calculation_method: 'abacus',
}

export const DEFAULT_MULTIPLY_OPTIONS = {
	...defaultGameConfig.multiply,
	calculation_method: 'oral',
}

export const DEFAULT_MULTIPLY_BASE_OPTIONS = {
	type: 'multiply_50_100',
	numbers: undefined,
	places: 50,
	calculation_method: 'oral',
}

export const DEFAULT_MULTIPLY_25X25_OPTIONS = {
	type: 'multiply_25x25',
	numbers: undefined,
	places: '-',
	calculation_method: 'oral',
}

export const DEFAULT_MULTIPLY_QUAD_OPTIONS = {
	type: 'multiply_quad',
	numbers: [11, 19],
	calculation_method: 'oral',
}

export const DEFAULT_NEGATIVE_OPTIONS = {
	...defaultGameConfig.negative,
	calculation_method: 'oral',
}

export const DEFAULT_DIVIDE_OPTIONS = {
	...defaultGameConfig.division,
	calculation_method: 'oral',
}
export const DEFAULT_COLUMNS_OPTIONS = {
	...defaultGameConfig.columns,
	calculation_method: 'oral',
}

const DEFAULT_GAME_CONFIG = {
	type: 'addition',
	repeat: '1',
	options: { ...DEFAULT_ADDITION_OPTIONS },
}

export default {
	name: 'homework-create',
	data() {
		return {
			tab: 'student',
			excludedStudents: [],
			groupStudents: [],
			gameConfigs: [],
			showModalUpdateLesson: false,
		}
	},
	components: {
		GameConfig,
		WarningMatific,
		ModalUpdateLesson,
		draggable
	},
	methods: {
		moveOrder(index, step) {
			if (index + step < 0 || index + step > this.gameConfigs.length - 1) return;

			let newConfigs = [...this.gameConfigs]

			const fromContent = newConfigs[index]
			const targetContent = newConfigs[index + step]

			newConfigs[index] = targetContent
			newConfigs[index + step] = fromContent

			this.gameConfigs = newConfigs
		},

		deleteHomework() {
			this.axios({
				method: 'delete',
				url: `lessons/homeworks/${this.$route.query.homework}`,
			}).then(resp => {
				this.$router.push({
					name: `${this.$route.fullPath.indexOf('group') >= 0 ? 'Group' : 'Profile'
						} Homework`,
					params: { id: this.$route.params.id },
				})
			})
		},
		saveHomework() {
			// check all error cases
			const isError = this.gameConfigs.some((config, i) => {
				const isError =
					config.options?.type === 'multiply' && !config.options.numbers?.length
				if (isError) {
					// highlight error field
					this.$refs[`config-${i}`][0].validateMultiply()
				}
				return isError
			})
			if (isError) return
			const paramsDate = getTime(this.$route.query.date)
			const order = this.$route.query.order

			let data = {
				order,
				year: paramsDate.year,
				month: paramsDate.month - 1,
				games: this.gameConfigs.map(config => {
					const result = {
						repeat: +config.repeat,
						type: config.type,
					}

					result.calculation_method = config.options.calculation_method

					if (config.type === 'addition' || config.type === 'columns') {
						result.option = config?.options?.option || ''
					}

					if (
						config.type === 'addition' ||
						config.type === 'abacus_random' ||
						config.type === 'anzan'
					) {
						result.digit_type = config.options.type

						result.speed = config.options.speed
						result.operation_number = config.options.length
						result.difficult = config.options.places
						if (
							(config.type === 'addition' && !config.options.digit_type)

						) {
							result.digit = config.options.digit
						} else if (config.type === 'abacus_random') {
							result.digit = config.options.digit[0]
							result.digit_type = config.options.digit.join('-')
							result.option = JSON.stringify(config.options.digit)
						}

						if (config.type === 'addition' && config.options.digit_type) {
							result.digit_type = config.options.digit_type
						}
					} else if (config.type === 'columns') {
						console.log("config type", config)
						result.with_columns = true
						result.calculation_method = config.options.calculation_method
						result.speed = config.speed || 1.6

						result.game_data = JSON.stringify({
							isTimerEnabled: config.options.isTimerEnabled,
							timerCount: config.options.timerCount
						})

						if (config.options.type === 'divide') {
							result.type = 'addition'
							result.digit_type = 'divide'
							result.operation_number = 1
							result.difficult = config.options.numbers[0]
							result.difficult_2 = config.options.numbers[1]
						} else if (config.options.type === 'negative') {
							result.type = 'addition'
							result.digit_type = 'negative'
							result.operation_number = config.options.length
							result.difficult = config.options.places
						} else {
							result.type = config.options.type.includes('multiply') ? 'multiply' : 'addition'
							result.digit_type = config.options.type
							result.operation_number = config.options.length
							result.difficult = config.options.places
							result.digit = String(config.options.digit)
						}

						if (config.options.type === 'anzan') {
							result.type = 'anzan'
							result.digit_type = config.options.digit_type
						}

						// Multiply configs

						if (
							config.options.type === 'multiply' ||
							config.options.type === 'multiply_50_100' ||
							config.options.type === 'multiply_25x25'
						) {
							result.difficult = config.options.places
							result.digit_type = config.options.type
							result.operation_number = 1
						}

						if (
							config.options.type === 'multiply_quad' ||
							config.options.type === 'multiply'
						) {
							result.numbers = config.options.numbers
						}


					} else if (config.type === 'divide') {
						result.digit_type = 'divide'
						result.difficult = config.options.numbers[0]
						result.operation_number = 1
						result.difficult_2 = config.options.numbers[1]
					} else if (config.type === 'multiply') {
						result.digit_type = config.options.type
						result.operation_number = 1

						if (
							config.options.type === 'multiply' ||
							config.options.type === 'multiply_50_100' ||
							config.options.type === 'multiply_25x25'
						) {
							result.difficult = config.options.places
						}

						if (config.options.type === 'multiply_50_100') {
							console.log('config', config.options)

							result.option = config.options.option
						}

						if (
							config.options.type === 'multiply_quad' ||
							config.options.type === 'multiply'
						) {
							result.numbers = config.options.numbers
						}
					} else if (config.type === 'negative') {
						result.digit_type = config.type
						result.speed = config.options.speed
						result.operation_number = config.options.length
						result.difficult = config.options.places
						// result.calculation_method = 'oral'
					}
					return result
				}),
			}
			if (this.$route.name === 'Profile Homework Create')
				data['user'] = this.$route.params.id
			else data['group'] = this.$route.params.id

			this.axios({
				method: 'post',
				url: 'lessons/homeworks',
				data: data,
			}).then(() => {
				if (this.$route.name === 'Profile Homework Create') {
					this.$store.state.homeworkGameConfig = []
					this.$router.push({
						name: 'Profile Homework',
						params: { id: this.$route.params.id },
					})
				} else {
					this.$store.state.homeworkGameConfig = []
					this.$router.push({
						name: 'Group Homework',
						params: { id: this.$route.params.id },
					})
				}
			})
		},
		addGameConfig() {
			const configsLength = this.gameConfigs?.length;

			this.gameConfigs.push({ ...DEFAULT_GAME_CONFIG, initialOrder: configsLength, isNew: true })
		},
		deleteConfig(index) {
			this.gameConfigs = this.gameConfigs.filter((_, i) => i !== index)
		},
		copyConfig(config) {
			// this.gameConfigs.push({ ...config })
		},
		deleteMatific() {
			this.gameConfigs = this.gameConfigs.filter(e => e.type === 'matific')
		},
		deleteNotMatific() {
			this.gameConfigs = this.gameConfigs.filter(e => e.type !== 'matific')
		},
	},
	computed: {
		hasMatific() {
			return this.gameConfigs.some(el => el.type === 'matific')
		},
	},
	beforeMount() {
		// get list of students in certain group
		if (this.$route.name === 'Group Homework Create') {
			this.axios({
				method: 'get',
				url: `users?role=student&group=${this.$route.params.id}`,
			}).then(resp => {
				resp.data.forEach(student => {
					this.groupStudents.push({
						value: student.id,
						label: `${student.first_name} ${student.last_name} ${student.middle_name}`,
					})
				})
			})
		}
	},
	created() {
		// If there are no `date` prop - redirect to Homework calendar
		if (this.$route.query.date === undefined) {
			return this.$router.push('/dashboard/homework')
		}
		// It can be create or edit homework. If there are `homework` prop -
		if (this.$route.query.homework !== undefined) {
			this.axios({
				method: 'get',
				url: `lessons/homeworks/${this.$route.query.homework}`,
			}).then(resp => {
				this.gameConfigs = resp.data.games.map((config, index) => {
					// convert from backend data type to frontend data type
					const options = {}
					const result = {
						type: config.type,
						repeat: config.repeat,
						/**
						 * @important
						 * we pass id by default in order to don't reset saved data
						 * on any change type we removes it, and work with
						 * config as with regular config
						 */
						id: config.id,
						initialOrder: index,
						options,
					}

					options.calculation_method = config.calculation_method

					if (config.type === 'addition' || config.type === 'columns' || config.type === 'multiply_50_100') {
						options.option = config.option
					}

					if (config?.with_columns) {
						const gameData = config.game_data ? JSON.parse(config.game_data) : {
							isTimerEnabled: false,
							timerCount: 30
						}

						console.log('game_data', config.game_data)

						options.isTimerEnabled = gameData?.isTimerEnabled || false
						options.timerCount = gameData?.timerCount || 30
					}

					if (
						config.type === 'addition' ||
						config.type === 'abacus_random' ||
						config.type === 'anzan'
					) {
						const isColumnsDivide =
							config.with_columns && config.digit_type === 'divide'
						const isColumnsNegative =
							config.with_columns && config.digit_type === 'negative'

						options.type = config.digit_type

						options.speed = config.speed
						options.length = config.operation_number
						options.places = config.difficult

						if (config.type === 'abacus_random') {
							options.type = 'abacus_random_2'
						}

						if (config.type === 'addition' || config.type === 'anzan' || config.type === 'abacus_random') {
							if (
								['anzan_random', 'anzan_minus', 'anzan_plus'].includes(
									config.digit_type
								)
							) {
								result.options.type = 'anzan'
								result.options.digit_type = config.digit_type
							} else if (config.type === 'abacus_random') {
								options.digit = JSON.parse(config.option)
							}
							else if (!isColumnsDivide && !isColumnsNegative) {
								options.digit = config.digit
							}
						}
						if (config?.with_columns) {
							result.type = 'columns'

							if (isColumnsDivide) {
								options.numbers = [config.difficult, config.difficult_2]
							}
						}
					} else if (config.type === 'divide') {
						options.numbers = [config.difficult, config.difficult_2]
					} else if (config.type === 'multiply') {
						options.type = config.digit_type

						if (
							options.type === 'multiply' ||
							options.type === 'multiply_50_100' ||
							options.type === 'multiply_25x25'
						) {
							options.places = config.difficult
						}

						if (options.type === 'multiply_50_100') {
							options.option = config.option
						}

						if (
							options.type === 'multiply_quad' ||
							options.type === 'multiply'
						) {
							options.numbers = config.numbers
						}

						if (config?.with_columns) {
							result.type = 'columns'
							// options.calculation_method = 'oral'
						}
					} else if (config.type === 'negative') {
						options.speed = config.speed
						options.length = config.operation_number
						options.places = config.difficult
					}

					return result
				})
			})
		}
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.ComponentForm {
	margin: 24px;
}

.control-buttons {
	display: flex;
	flex-wrap: wrap;
	margin-top: 20px;
}

.mybtn-outline {
	outline: none;
	box-sizing: border-box;
	border-radius: 16px;
	border: 1px solid var(--orange-color);
	color: var(--orange-color);
	padding: 16px 30px;
	min-height: 56px;
	display: inline-flex;
	align-items: center;
	background-color: transparent;
	margin-right: 24px;
	margin-bottom: 14px;
	transform: scale(1);
	transition: transform 0.25s ease-in-out;

	&:hover {
		transform: scale(1.05);
	}

	i,
	svg {
		margin-right: 10px;
	}
}

.mybtn-outline-violet {
	color: var(--violet-color);
	border: 1px solid var(--violet-color);
}

#dashboard .add-config {
	color: #e5a33f;
	display: inline-block;
	margin-top: 15px;
	margin-bottom: 15px;
	font-size: 40px;
}

.tab-content {
	padding-top: 20px;
	padding-bottom: 20px;
}

@media screen and (max-width: 1200px) {
	.control-buttons {
		display: block;

		margin-top: 20px;
		margin-bottom: 20px;
	}
}
</style>

<style>
.multiselect-error .multiselect__tags {
	border: 1px solid red !important;
}
</style>
